/*
 * @Author: zhangsusha@58.com
 * @LastEditors: zhangsusha
 * @LastEditTime: 2023-11-21 15:30:00
 * @FilePath: /ershoufang-common-nuxt/pages/old/common/mixins/ifFromApp.js
 * @Description: zhangsusha
 * @Date: 2023-03-08 14:48:02
 * Copyright (c) 2023 by zhangsusha/五八, All Rights Reserved.
 */
// const request = require("src/utils/request")();

import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            _mixin_request: 'getRequest'
        }),
        ifFromApp() {
            let exceptWordArr = ['i-broker2', 'a-broker', 'wuba', 'webapp', 'a-ajlz', 'i-ajlz'];
            let app = this._mixin_request.isFromApp;
            // 判断是否来自经纪人 app
            // if (app === 'i-broker2' || app === 'a-broker') {
            //判断是否来自其他的环境设置的变量
            if (exceptWordArr.indexOf(app) > -1) {
                return false;
            }
            return this._mixin_request.isFromApp;
        },
        ifFrom58App() {
            let app = this._mixin_request.isFromApp;
            return app && app === 'wuba';
        },
        isAjlzApp() {
            let app = this._mixin_request.isFromApp;
            return app && (app === 'a-ajlz' || app === 'i-ajlz');
        },
        ifFromMiniProgram() {
            return this._mixin_request.ifFromMiniProgram;
        },
        ifFromToutiaoProgram() {
            return this._mixin_request.ifFromToutiaoProgram;
        },
        ifFromWechat() {
            let app = this._mixin_request.isFromApp;
            return app && app === 'webapp';
        },
        ifFromBrokerApp() {
            let app = this._mixin_request.isFromApp;
            return app === 'i-broker2' || app === 'a-broker';
        },
        // ifFrom
        //APP:anjuke 58
        ifFromAjkOrWb() {
            return this.ifFromApp || this.ifFrom58App;
        },
        //APP
        ifFromCommonApp() {
            return this.ifFromApp || this.ifFrom58App || this.ifFromBrokerApp;
        },
        //H5
        ifFromBrowser() {
            return !(
                this.ifFromApp ||
                this.ifFrom58App ||
                this.ifFromBrokerApp ||
                this.ifFromWechat ||
                this.ifFromMiniProgram ||
                this.ifFromToutiaoProgram
            );
        },
        //58H5
        ifFromBrowserInWb() {
            let origin = this._mixin_request.origin;
            return this.ifFromBrowser && origin && (origin.indexOf('.58.com') > -1 || origin.indexOf('.58.test') > -1);
        },
        ifFromBrowserIn58() {
            return this.ifFromBrowserInWb;
            /*let origin = this._mixin_request.origin
            return this.ifFromBrowser && origin && origin.indexOf('.58.com') > -1*/
        },
        //58 domain
        ifFromWbHost() {
            let origin = this._mixin_request.origin;
            return origin && (origin.indexOf('.58.com') > -1 || origin.indexOf('.58.test') > -1);
        },
        //anjukeH5
        ifFromBrowserInAnjuke() {
            return this.ifFromBrowser && !this.ifFromBrowserInWb;
        },
        ifFromWuba() {
            return this.ifFrom58App || this.ifFromBrowserInWb;
        }
    }
};
